// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__4vqEI","key":"Card_key__sNAaK","data":"Card_data__AEG7H"};